export const DEFAULT_LOCALE = "en-US";
export const BUNDLE_NAME = "RTTVWidgetTranslations";
